import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
export const TeamCarousel: React.FC = () => {
  const navigate = useNavigate();
  const teamMembers = [{
    id: 'rocco',
    name: 'Rocco',
    role: 'Oprichter & Strateeg',
    story: 'Met meer dan 10 jaar ervaring in webdevelopment help ik klanten met technische oplossingen die werken. Ik zorg dat jouw website niet alleen mooi is, maar ook snel, veilig en goed vindbaar.',
    image: 'https://cdn.magicpatterns.com/uploads/3gNHu8EmmCiAuc7tUYPC6J/Mogelijk_voor_website_(1).jpg'
  }, {
    id: 'beer',
    name: 'Beer',
    role: 'SEO Specialist',
    story: 'Design is mijn passie. Ik zorg ervoor dat jouw website niet alleen mooi is, maar ook gebruiksvriendelijk en doelgericht. Met mijn achtergrond in conversie optimalisatie help ik je groeien.',
    image: 'https://cdn.magicpatterns.com/uploads/j3tkPhdq8waLuNZ7ESBT4s/Mogelijk_voor_website_(10).jpg'
  }, {
    id: 'alex',
    name: 'Alex',
    role: 'Webdesigner',
    story: 'Als projectmanager ben ik jouw eerste aanspreekpunt. Ik zorg ervoor dat jouw project soepel verloopt, van eerste gesprek tot oplevering. Ik begrijp wat een website moet doen.',
    image: 'https://cdn.magicpatterns.com/uploads/5ccyafcfpYqxWEyuCGARef/Mogelijk_voor_website_(19).jpg'
  }, {
    id: 'norden',
    name: 'Norden',
    role: 'Ads & Data Specialist',
    story: 'Als mascotte van Noord Digital ben ik het gezicht van ons bureau. Ik help je door het proces en zorg voor een persoonlijke touch. Ik ben er om je te begeleiden.',
    image: 'https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="w-full py-24 bg-white overflow-hidden" data-id="element-645">
      <div className="container mx-auto px-4 md:px-6 max-w-[1200px]" data-id="element-646">
        <div className="text-center mb-16" data-id="element-647">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-648">
            Maak kennis met ons team
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-649">
            Een klein, gedreven team met grote kennis van B2B online groei.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-650">
          {teamMembers.map(member => <motion.div key={member.id} variants={cardVariants} whileHover="hover" className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center border border-gray-100 relative group" data-id="element-651">
              <div className="w-[180px] h-[180px] rounded-full overflow-hidden mb-6 bg-gray-50 border-4 border-white shadow-sm" data-id="element-652">
                <motion.img variants={{
              hover: {
                scale: 1.05
              }
            }} transition={{
              duration: 0.4,
              ease: 'easeOut'
            }} src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-653" />
              </div>

              <h3 className="font-semibold text-[18px] text-gray-900 mb-1" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-654">
                {member.name}
              </h3>
              <p className="text-[14px] text-[#607697] mb-4 font-medium" data-id="element-655">
                {member.role}
              </p>
              <p className="text-gray-600 text-sm mb-6 flex-grow leading-relaxed" data-id="element-656">
                {member.story}
              </p>

              <button type="button" onClick={() => navigate(`/over-ons/${member.id}`)} className="text-[#004AC7] font-medium text-sm hover:underline mt-auto inline-flex items-center gap-1" data-id="element-657">
                Bekijk profiel &rarr;
              </button>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};